module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL2.5c68616d.mp3";